import { Schema, NodeSpec } from 'prosemirror-model';

export const nodes: { [key: string]: NodeSpec } = {
  doc: {
    content: 'inline*',
  },

  text: {
    group: 'inline',
  },

  // eslint-disable-next-line camelcase
  hard_break: {
    inline: true,
    group: 'inline',
    selectable: true,
    parseDOM: [{ tag: 'br' }],
    toDOM() {
      return ['br'];
    },
  },
};

export default new Schema({
  nodes,
});
